import { defineMessages } from '@jutro/locale';

export default defineMessages({
    paymentOptions: {
        id: 'quoteandbind.views.payment-details.Payment Options',
        defaultMessage: 'Payment Options',
    },
    averageMonthlyPremium: {
        id: 'quoteandbind.views.payment-details.Average Monthly Premium',
        defaultMessage: 'Average Monthly Premium:',
    },
    paymentDetails: {
        id: 'quoteandbind.views.payment-details.Payment Details',
        defaultMessage: 'Payment Details',
    },
    totalPremium: {
        id: 'quoteandbind.views.payment-details.Total Premium:',
        defaultMessage: 'Total Premium:',
    },
    paymentBuyNow: {
        id: 'quoteandbind.views.payment-details.Buy Now',
        defaultMessage: 'Buy Now'
    }
});
